import { render, staticRenderFns } from "./header-wrap.vue?vue&type=template&id=47440aae&scoped=true&"
import script from "./header-wrap.vue?vue&type=script&lang=js&"
export * from "./header-wrap.vue?vue&type=script&lang=js&"
import style0 from "./header-wrap.vue?vue&type=style&index=0&id=47440aae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47440aae",
  null
  
)

export default component.exports